(function(){
  if(window.__mtReveal)return;window.__mtReveal=true;
  if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  document.documentElement.classList.add('mt-anim');
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px'});
  function scan(){document.querySelectorAll('.mt-reveal:not(.is-in)').forEach(function(el){
    var r=el.getBoundingClientRect(); if(r.top<window.innerHeight){el.classList.add('is-in');} else io.observe(el);});}
  if(document.readyState!=='loading')scan();else document.addEventListener('DOMContentLoaded',scan);
  document.addEventListener('shopify:section:load',scan);
})();
